import { Helmet } from "react-helmet-async";
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs'

const HybridLearningPlatforms = () => {
    return (
        <section>
            <div className="about-mijsc-section w-full bg-cover h-fit pb-5">
                {/* SEO */}
                <Helmet>
                    <title>Hybrid Learning Platforms</title>
                    <meta
                        name="description"
                        content="Explore the Hybrid Learning Platforms of LMP, featuring Digital Learning through Swayam & IIMBx, online interactions with experts, and physical conclaves at IIMB."
                    />
                </Helmet>
                <BreadCrumbs />

                <div className=' w-[94%] text-justify'>
                    <section className='w-full h-fit md:mx-10 mx-5 mb-5 ' >
                        <h1 className="md:text-4xl text-lg  font-semibold pt-10 uppercase text-left">Hybrid Learning <br />
                            <span className="text-green-600">Platforms</span>
                        </h1>
                    </section>
                </div>

                <div className="w-full mx-auto ">
                    <section className="w-full space-y-10 md:space-y-16 mt-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center w-full   mx-auto px-5 md:px-10">
                            <div
                                className="rounded-xl w-full aspect-[13/9] transition-all duration-700 bg-center bg-no-repeat"
                                style={{
                                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/digital-learning.png)`,
                                    backgroundSize: "contain"
                                }}
                            />
                            <div className="text-left">
                                <h2 className="mt-8 md:mt-0 md:text-2xl text-lg text-green-600 font-semibold mb-4">
                                    Digital Learning
                                </h2>
                                <p className="text-gray-600 text-sm my-2">
                                    In the Digital Learning mode, LMP participants can access content through <b> Swayam and IIMBx </b> , which provide a comprehensive learning experience across four key quadrants:</p>


                                <p className="mt-5 text-gray-600 text-sm my-2 font-semibold">(1) video lectures </p>
                                <p className="text-gray-600 text-sm my-2 font-semibold">(2) downloadable and printable reading materials </p>
                                <p className="text-gray-600 text-sm my-2 font-semibold">(3) self-assessment tests via quizzes and exams </p>
                                <p className="mb-5 text-gray-600 text-sm my-2 font-semibold">(4) an online discussion forum to clarify doubts </p>
                                <p className="text-gray-600 text-sm my-2">Swayam is an initiative by the Government of India, while IIMBx is an IIMB initiative towards MOOCs mode of Digital Learning. Through Swayam, the Self-Learning mode is facilitated for both the faculty in Phase 1 and students in Phase 2, for every module of the course.</p>

                            </div>
                        </div>

                        <div className="bg-gray-50 w-full py-10 md:py-16">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center w-full   mx-auto px-5 md:px-10">

                                <div>
                                    <div className="w-full h-full content-center">
                                        <h2 className="text-start md:text-2xl text-lg text-green-600 font-semibold mb-4">
                                            Online Interactions with Industry Experts
                                        </h2>
                                        <p className="text-justify text-gray-600 text-sm my-2">
                                            At the end of the self-learning mode, online interactions with industry experts are designed for faculty to create impactful sessions that deepen understanding of key concepts. Similarly, for students, faculty can plan such interactions after their certification as Lean Experts.
                                        </p>
                                        <p className="text-justify text-gray-600 text-sm my-2">
                                            The sessions include participant assessments through assignments, case study discussions, doubt clearance, and a post-session assignment that must be completed and uploaded to MOODLE, the Learning Management System at IIMB. These assignments are later reviewed and assessed by the respective Module Directors, with grades and feedback provided to the participants.
                                        </p>
                                        <p className="text-justify text-gray-600 text-sm my-2">
                                            The final assessment is based on multiple criteria, including attendance, assignment submissions, project work, and a final exam.
                                        </p>
                                    </div>
                                </div>

                                <div
                                    className="rounded-xl w-full aspect-[13/9] transition-all duration-700 bg-center bg-no-repeat"
                                    style={{
                                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/online-interactions-with-experts.png)`,
                                        backgroundSize: "contain",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="w-full py-10">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-5 items-center w-full   mx-auto px-5 md:px-10">
                                <div
                                    className="rounded-xl w-full aspect-[13/9] transition-all duration-700 bg-center bg-no-repeat"
                                    style={{
                                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/physical-interactions.jpeg)`,
                                        backgroundSize: "contain"
                                    }}
                                />


                                <div className="text-left">
                                    <h2 className="md:text-2xl text-lg text-green-600 font-semibold mb-4">
                                        Physical Interactions: LMP Conclave @ IIMB
                                    </h2>
                                    <p className="text-gray-600 text-sm my-2">
                                        The LMP Conclave at IIMB is designed to offer participants an impactful experience through lectures by IIMB professors, industry visits, and interactions with industry experts. Over the course of the three-day LMP Conclave, participants are immersed in learning that provides them with a closer look at Lean Principles.
                                    </p>

                                    <p className="text-gray-600 text-sm my-2">
                                        Industry visits, including shop floor tours where lean practices are implemented, offer rich, hands-on learning experiences. Lectures by IIMB professors provide high-quality insights into areas of their expertise as well as valuable teaching pedagogical methods. The world-class infrastructure and serene green campus of IIMB enhance the overall learning experience, creating an enriching and memorable atmosphere.
                                    </p>
                                    <p className="text-gray-600 text-sm my-2">

                                        These immersive interactions allow participants to gain deep knowledge and practical insights, especially from their engagements with industry experts on the application of Lean Principles. This enhanced learning will equip them to guide students in academic and research areas, particularly in the manufacturing field, through the effective application of Lean Principles.
                                    </p>
                                </div>


                            </div>
                        </div>

                    </section>
                </div >



            </div >
        </section >
    )
}

export default HybridLearningPlatforms
